import type { ReactNode } from "react";

/**
 * Break-glass. Two things the connect popup needs that no ui-core primitive
 * expresses:
 *
 *  - a muted colour painted across the whole viewport, so the card in the
 *    middle reads as a card. ui-core has Panel (a card) but no page surface.
 *  - centred text *inherited* by whatever body the flow renders into the card.
 *    `T` centres one element at a time, and the bodies live in
 *    ConnectShopifyScreen, so the alignment has to come from an ancestor.
 */
export function ShopifyConnectPageSurface({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-light-background p-6 text-center">
      {children}
    </div>
  );
}
